import { ActivityMoment, EventMoment, MomentType } from 'types'
import { makeUniqueString } from 'utils'
import gaugeIcon from '../assets/moment-icons/activity-gauge.svg'
import hourglassIcon from '../assets/moment-icons/activity-hourglass.svg'
import explorerIcon from '../assets/moment-icons/explorer.svg'
import publicIcon from '../assets/moment-icons/public.svg'

export interface PartialTemplate {
  id: string
  title: string
}

function nextMomentId(moments?: EventMoment[]): number {
  const maxId = moments?.reduce((max, moment) => Math.max(max, moment.id), -1) ?? -1
  return maxId + 1
}

export function createMoment(
  moments: EventMoment[],
  type: MomentType,
  template: PartialTemplate
): EventMoment {
  const id = nextMomentId(moments)

  let title = ''
  switch (type) {
    case 'explorer':
      title = template.title
      break
    case 'public':
      title = 'Self Registration'
      break
    case 'activity':
      title = 'Activity'
      break
  }

  title = makeUniqueString(
    title,
    moments.map(m => m.title)
  )

  const moment = {
    id,
    type: type,
    title,
    template: { id: template.id },
  } as EventMoment

  if (moment.type === 'activity') moment.activityType = 'count'

  return moment
}

export interface MomentOption {
  label: string
  iconSrc: string
  type: MomentType
}

export const momentOptions: MomentOption[] = [
  { label: 'Explorer', iconSrc: explorerIcon, type: 'explorer' },
  { label: 'Self Registration', iconSrc: publicIcon, type: 'public' },
  { label: 'Activity', iconSrc: hourglassIcon, type: 'activity' },
]

export interface ActivityMomentOption {
  label: string
  iconSrc: string
  type: ActivityMoment['activityType']
}

export const activityMomentOptions: ActivityMomentOption[] = [
  { label: 'Count', iconSrc: gaugeIcon, type: 'count' },
  { label: 'Timed', iconSrc: hourglassIcon, type: 'timed' },
]
